import { ensureIsEnvironment } from '@lib/home-wizard/domain-types';

export const ENVIRONMENT = ensureIsEnvironment(import.meta.env.PUBLIC_ENVIRONMENT);
